export async function importDynamicData(path: string): Promise<any> {
  const filePath = path.charAt(0) === '/' ? path.substring(1) : path;
  const { default: data } = await import(`../data/${filePath}`);

  return data;
}
